import { Box, Brand, Img, LogoAt, Page, Text } from "../primitives";
const LINES = [
    { top: 156, text: "مرحلة 01", heading: 20, right: 1091 },
    { top: 190, text: "نبدأبالتواصللفهم تفاصيل المشروع: المكان (منزل – مكتب" },
    { top: 216, text: "– فندق)، نوع الفن، الأبعاد وعدد اللوحات. اللون و النوع" },
    { top: 241, text: "التصميم (تشكيلي- واقعي - خيالي...) العدد مفرد او سيت ." },
    { top: 295, text: "مرحلة 02", heading: 17, right: 1087.5 },
    { top: 327, text: "تقديم المقترحات: نقترح لوحات جاهزة من معرضنا أو تصاميم", right: 1087.5 },
    { top: 348, text: "مخصصة، مع عرض سعر مفصّل حسب الفئة المختارة(Origin" },
    { top: 428, text: "مرحلة 03", heading: 17, right: 1087.5 },
    { top: 458, text: "اعتماد المشروع: نحدد المواصفات النهائية عدد النسخ، نوع" },
    { top: 483, text: "الطباعة أو اللمسات اليدوية، والمدة الزمنية للتنفيذ." },
    { top: 554, text: "مرحلة 04", heading: 17, right: 1087.5 },
    { top: 584, text: "تنفيذ العمل: يبدأ التنفيذ باحترافية عالية تحت إشراف فني" },
    { top: 609, text: "مباشر لضمان جودة كل لوحة." },
    { top: 670, text: "مرحلة 05", heading: 17, right: 1088 },
    { top: 700, text: "نسلم اللوحات: بالطريقة المتفق عليها (مباشرة أو شحن)،" },
    { top: 725, text: "جاهزة للعرض بأعلى مستوى." },
];
export function WorkflowPage() {
    return (<Page>
      <Box x={0} y={0} w={603.2} h={810} style={{ background: "#000000", overflow: "hidden" }}>
        <Img src="/proposal-assets/template/workflow-photo.jpg" x={3.9} y={-66} w={667.4} h={943.7}/>
        <Box x={0} y={0} w={603.2} h={810} style={{ background: "#000000", opacity: 0.372 }}/>
      </Box>
      {/* hairline present along the bottom edge of the reference page */}
      <Box x={603.2} y={808.6} w={521.8} h={1.4} style={{ background: "#88a201" }}/>
      <LogoAt cx={77.8} cy={94.1} w={31.7} color="#ffffff"/>
      <Brand right={1085} top={64} size={33} color="#000000"/>

      {LINES.map((line) => (<Text key={line.top} right={line.right ?? 1092} top={line.top} size={line.heading ?? 17} weight={line.heading ? 700 : 400} color="#000000">
          {line.text}
        </Text>))}
      {/* closing Latin fragment of phase 02, kept in its visual order as in the reference */}
      <Text right={1092} top={375} size={17} color="#000000" dir="ltr">
        .(– Edition – Prime
      </Text>
    </Page>);
}
